/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CircleGeometry
 */
export interface CircleGeometry {
    /**
     * 
     * @type {string}
     * @memberof CircleGeometry
     */
    type: CircleGeometryTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof CircleGeometry
     */
    coordinates: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof CircleGeometry
     */
    radius: number;
}


/**
 * @export
 */
export const CircleGeometryTypeEnum = {
    Point: 'Point'
} as const;
export type CircleGeometryTypeEnum = typeof CircleGeometryTypeEnum[keyof typeof CircleGeometryTypeEnum];


/**
 * Check if a given object implements the CircleGeometry interface.
 */
export function instanceOfCircleGeometry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "coordinates" in value;
    isInstance = isInstance && "radius" in value;

    return isInstance;
}

export function CircleGeometryFromJSON(json: any): CircleGeometry {
    return CircleGeometryFromJSONTyped(json, false);
}

export function CircleGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CircleGeometry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
        'radius': json['radius'],
    };
}

export function CircleGeometryToJSON(value?: CircleGeometry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'coordinates': value.coordinates,
        'radius': value.radius,
    };
}

